<div class="login-payment-container">
  <section class="login col-12" [ngClass]="showGuestRegister ? 'col-xl-8 col-lg-9' : ''">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12" [ngClass]="fullSize?'':'col-md-7 col-xl-6 container container-wrapper'">
          <div class="card-deck">
            <section class="card">
              <div class="card-img-top">
                <h3>{{ 'Sign In' | translate }}</h3>
                <p>{{ 'You already have an account'| translate }}</p>
              </div>
              <div class="card-body">
                <app-login (eventLoggedIn)="onLoggedIn()" (eventBack)="onBack()" (eventRegister)="onRegister()"
                  [showBack]="showBack" [showRegistrationUrl]="showRegistrationUrl" [email]="email"
                  [readOnlyEmail]="readOnlyEmail" [showRememberMe]="showRememberMe">
                </app-login>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section *ngIf="showGuestRegister" class="col-12 col-xl-4 col-lg-3">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h3>{{'User-Guest' | translate}}</h3>
          <p>
            {{'I do not want to take advantage of the customer and want make the order as a guest without registration.' |
            translate}}
          </p>
        </div>
        <div class="col-12">
          <div class="button button-right button-black float-left">
            <button (click)="onRegisterAsGuest()"></button>
            <span class="bar"></span>
            <label class="label-register-guest">{{'Order as a Guest' | translate}}</label>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
